import React, { useEffect } from 'react';
import './collab-list-item.styles.scss';
import { properCase } from '@/utils/properCase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmarkSquare } from '@fortawesome/free-solid-svg-icons';
import { format } from 'date-fns';

const CollabListItem = ({
  collab,
  removeCollaborator,
}) => {
 
  return (
    <div
      key={collab.appId}
      className='collab-list-item g-list-item'>
      <div className='collab-item-name'>
        <div>{collab.lName}, {collab.fName}</div>
        <div className='meta'>{collab.email}</div>
      </div>
      {
        (collab.id && collab.id.includes('_invite')) 
        ?
        <div className='buttons'>
          <div className='meta'>Invited {format(new Date(collab.ts_created), 'P')}</div>
          <div>{properCase(collab.role[0])}</div>

          <button
            className={`g-button small-btn ${collab.role[0] === 'owner' ? 'disabled' : ''
              }`}
            onClick={() => removeCollaborator(collab.inviteAppId, collab.id)}>
            <FontAwesomeIcon icon={faXmarkSquare} />
          </button>
        </div>
        :
        <div className='buttons'>
          <div>{properCase(collab.role)}</div>

          <button
            className={`g-button med-btn ${collab.role === 'owner' ? 'disabled' : ''
              }`}
            onClick={() => removeCollaborator(collab.appId)}>
            <FontAwesomeIcon icon={faXmarkSquare} />
          </button>
        </div>
      }
    </div>
  )
}

export default CollabListItem